export default "__VITE_ASSET__dKSb78tP__"